var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SearchBannerFormItem",
    {
      staticClass: "form-item-city-dropdown",
      class: { loading: _vm.loading },
      attrs: {
        id: _vm.id,
        label: _vm.label,
        "store-namespace": _vm.storeNamespace,
        "drawer-config": _vm.drawerConfig,
        "display-value": _vm.displayValue,
        active: _vm.isActive,
        "is-desktop": _vm.isDesktop,
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
        close: function ($event) {
          return _vm.$emit("close", $event)
        },
      },
    },
    [
      _c("CitySelect", {
        attrs: {
          labels: _vm.citySelectLabels,
          value: _vm.selectedCityLabel,
          "is-opened": true,
          "is-in-filter": true,
          "loader-type": "absolute",
        },
        on: { select: _vm.handleCitySelect, loading: _vm.handleCityLoading },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }